import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  Validators,
  WForm,
  WFormControl,
} from "rectangular-forms";
import { tap } from "rxjs";

import {
  inputMaxLengthFn,
  onlyDigits,
  WDropdown,
  WInputText,
} from "../../common/components/TemplateContainer/InputTemplates";
import { SaveButton } from "../../common/components/TemplateContainer/SaveButton";
import { TemplateInputContainer } from "../../common/components/TemplateContainer/TemplateContainer";
import IconVectorRightBlue from "../../images/icon_button_users_blue.svg";
import { RUC_MAX_LENGTH } from "../../utils/valueStaticConstants";
import { DivSearcRuc } from "../AdditionalVolanteModal/AdditionalRucsModalStyles";

export const AdditionalRucsModalAdminSearch = (props) => {
  const { getCreditThirdbillableRucs, setDataSearch } = props;
  const toast: any = useRef();
  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        billable_ruc_name: new FormControl(),
        type_option: new FormControl(null, [Validators.required]),
        billable_ruc: new FormControl(),
      });
      form
        .get("type_option")
        .valueChanges.pipe(
          tap((type_option) => {
            const billableRucNameFC = form.get("billable_ruc_name");
            const billableRucFC = form.get("billable_ruc");
            billableRucNameFC.clearValidators();
            billableRucFC.clearValidators();
            if (type_option === "ruc") {
              billableRucFC.setValidators([
                Validators.required,
                Validators.minLength(11),
                Validators.maxLength(11),
                Validators.pattern(/^[0-9]{11,11}$/),
              ]);
            } else {
              billableRucNameFC.setValidators([
                Validators.required,
                Validators.maxLength(75),
                Validators.pattern(/^[A-Z a-z \-ÁÉÍÓÚÑáéíóúñ,. 0-9 &]*$/),
              ]);
            }
            billableRucNameFC.updateValueAndValidity();
            billableRucFC.updateValueAndValidity();
          })
        )
        .subscribe();
      form.patchValue(data);
      return form;
    },
    onSubmit: (form) => {
      const data = form.value;
      if (form.invalid) {
        toast.current.show({
          summary:
            "Completar todos los campos obligatorios antes de continuar. ¡Gracias!",
          contentClassName: "",
        });

        return;
      }
      setDataSearch(data);
      getCreditThirdbillableRucs.execute({ data });
    },
  });
  const formConfigLoadSucceed = formConfig.loadSucceed;

  useEffect(() => {
    formConfigLoadSucceed({ type_option: "r_s" });
    // eslint-disable-next-line
  }, [formConfigLoadSucceed]);

  const typeOption = formConfig.form?.get("type_option").value;
  const billableRuc = formConfig.form?.get("billable_ruc").valid;
  const billableRucName = formConfig.form?.get("billable_ruc_name").valid;

  return (
    <DivSearcRuc>
      <Toast ref={toast}></Toast>
      <WForm
        formConfig={formConfig}
        style={{ width: "100%" }}
        globalErrorMessages={{
          required: "Campo requerido",
        }}
      >
        <div
          className="p-grid"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div className="p-col-12 p-md-5">
            <WFormControl name="type_option">
              <TemplateInputContainer label="TIPO DE BÚSQUEDA:">
                <WDropdown
                  options={[
                    { label: "RAZÓN SOCIAL", value: "r_s" },
                    { label: "RUC", value: "ruc" },
                  ]}
                  width="100%"
                  placeholder="(Seleccione el tipo de ruc o razón social)"
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          {typeOption === "r_s" && (
            <div className="p-col-12 p-md-5">
              <WFormControl
                name="billable_ruc_name"
                errorMessages={{ pattern: "Razón social no valido" }}
              >
                <TemplateInputContainer
                  label="RUC O RAZÓN SOCIAL:"
                  position="absolute"
                >
                  <WInputText width="100%" placeholder="Escriba razón social" />
                </TemplateInputContainer>
              </WFormControl>
            </div>
          )}
          {typeOption === "ruc" && (
            <div className="p-col-12 p-md-5">
              <WFormControl
                name="billable_ruc"
                errorMessages={{ pattern: "Ruc inválido" }}
              >
                <TemplateInputContainer
                  label="RUC O RAZÓN SOCIAL:"
                  position="absolute"
                >
                  <WInputText
                    width="100%"
                    placeholder="Escriba RUC"
                    maxLength={RUC_MAX_LENGTH}
                    onInput={inputMaxLengthFn}
                    onKeyPress={onlyDigits}
                  />
                </TemplateInputContainer>
              </WFormControl>
            </div>
          )}
          <div
            className="p-col-12 p-md-2"
            style={{
              display: "flex",
              alignItems: "flex-end",
            }}
          >
            <SaveButton
              width="100%"
              height="5rem"
              backgroundColor={
                !billableRuc || !billableRucName ? "#002e6c70" : "#002E6C"
              }
              iconRight={IconVectorRightBlue}
              isDisabled={!billableRuc || !billableRucName}
            />
          </div>
        </div>
      </WForm>
    </DivSearcRuc>
  );
};
